import axios from 'axios';

const backendUrl = `https://${process.env.REACT_APP_API_DNS}/api/regions`;

export const AllCities = async() => { // ok
    
    try {
        const response = await axios.get(`${backendUrl}/cities`);
        return response.data;
    }catch(error){
        console.error('error: ', error);
        throw error;
    }
}
